import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import '../styles/components/itinerary/ItineraryButtons.css';
import '../styles/components/itinerary/ItineraryLayout.css';
import ItineraryContent from './itinerary/ItineraryContent';
import { usePlaceContext } from './itinerary/PlaceContext';

const Itinerary = ({
  onCreateNew,
  onRenameItinerary,
  onDeleteItinerary,
  itineraries,
  selectedItinerary = null,
  setSelectedItinerary,
  isSectionOpen,
  isCreatingItinerary,
  isRenamingItinerary,
  isDeletingItinerary,
  isUpdatingPrivacy,
  onUpdatePrivacy,
  toggleMap,
  isSmallScreen,
  showMap,
  readOnly
}) => {
  const [columns, setColumns] = useState([]);
  const { } = usePlaceContext();

  useEffect(() => {
    if (selectedItinerary) {
      setColumns(selectedItinerary.columns || []);
    }
  }, [selectedItinerary]);

  return (
    <section className="itinerary-layout">
      {isSectionOpen && (
        <ItineraryContent
          selectedItinerary={selectedItinerary}
          columns={columns}
          onCreateNew={onCreateNew}
          onRenameItinerary={onRenameItinerary}
          onDeleteItinerary={onDeleteItinerary}
          onUpdatePrivacy={onUpdatePrivacy}
          isCreatingItinerary={isCreatingItinerary}
          isRenamingItinerary={isRenamingItinerary}
          isDeletingItinerary={isDeletingItinerary}
          isUpdatingPrivacy={isUpdatingPrivacy}
          toggleMap={toggleMap}
          isSmallScreen={isSmallScreen}
          showMap={showMap}
          readOnly={readOnly}
        />
      )}
      <div id="aria-live-region" aria-live="assertive" style={{ position: 'absolute', width: '1px', height: '1px', overflow: 'hidden', clip: 'rect(0, 0, 0, 0)' }}></div>
    </section>
  );
};

Itinerary.propTypes = {
  onCreateNew: PropTypes.func.isRequired,
  onRenameItinerary: PropTypes.func.isRequired,
  onDeleteItinerary: PropTypes.func.isRequired,
  itineraries: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    columns: PropTypes.array,
    tags: PropTypes.array,
  })).isRequired,
  selectedItinerary: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    columns: PropTypes.array,
    tags: PropTypes.array,
  }),
  setSelectedItinerary: PropTypes.func.isRequired,
  isSectionOpen: PropTypes.bool.isRequired,
  isCreatingItinerary: PropTypes.bool.isRequired,
  isRenamingItinerary: PropTypes.bool.isRequired,
  isDeletingItinerary: PropTypes.bool.isRequired,
  isUpdatingPrivacy: PropTypes.bool.isRequired,
  onUpdatePrivacy: PropTypes.func.isRequired,
  toggleMap: PropTypes.func.isRequired,
  isSmallScreen: PropTypes.bool.isRequired,
  showMap: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool,
};

export default Itinerary;
